import { Button, SearchInput } from '@/components';
import React, { useEffect, useState } from 'react';
import BiCustomerTable from './BiCustomerTable';
import {
  ModalProvider,
  useModal,
} from '../../../components/common/modal/ModalContext';
import CreateBiCustomer from './CreateBiCustomer';
import { useBiCustomer } from '@/context/biCustomerContext/BiCustomerContextProvider';
import { useDebouncedCallback } from '@/utils/useDebouncedCallback';

const BiCustomerView = () => {
  const { openModal, closeModal } = useModal();
  const {
    searchQuery,
    setSearchQuery,
    fetchBiCustomerData,
    currentPage,
    setCurrentPage,
    sendBiCustommerMonthlyReportApi,
  } = useBiCustomer();
  const [inputValue, setInputValue] = useState('');

  const handleOpenModal = () => {
    openModal(
      <CreateBiCustomer closeModal={closeModal} />,
      'Create Bi Customer',
    );
  };

  const debouncedSetSearchQuery = useDebouncedCallback((val) => {
    setSearchQuery(val);
    setCurrentPage(0);
  }, 300);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    debouncedSetSearchQuery.call(val);
  };

  useEffect(() => {
    fetchBiCustomerData();
  }, [searchQuery, currentPage]);

  return (
    <>
      <div className="flex justify-between mb-5">
        <Button onClick={sendBiCustommerMonthlyReportApi}>
          Monthly Customer File
        </Button>
        <div className="flex gap-5">
          <SearchInput
            placeholder="Search Customers..."
            value={inputValue}
            onChange={handleSearchChange}
          />
          {/* <Button onClick={handleOpenModal}>Add Customer</Button> */}
        </div>
      </div>
      <BiCustomerTable />
    </>
  );
};

const App = () => (
  <ModalProvider>
    <BiCustomerView />
  </ModalProvider>
);

export default App;
